import { render, staticRenderFns } from "./PayRouter.vue?vue&type=template&id=da5a5c6c"
import script from "./PayRouter.vue?vue&type=script&lang=js"
export * from "./PayRouter.vue?vue&type=script&lang=js"
import style0 from "./PayRouter.vue?vue&type=style&index=0&id=da5a5c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports